export const COOKIE_KEYS = {
  AUTH_TOKEN: 'auth_token',
}